export function StreamFallback({ label = "Loading live data" }: { readonly label?: string }) {
  return (
    <div className="stream-fallback" role="status" aria-live="polite">
      {label}…
    </div>
  );
}
